module.exports = __webpack_public_path__ + "img/rib.876d8439.svg";